import { useTexts } from '../../../../contexts/TextsContext';
import { resolveAssetUrl } from '../../../../utils/utils';
import classes from './hero.module.scss';

const Hero = () => {
    const texts = useTexts();

    return (
        <section className={classes.Hero}>
            <div className={classes.Inner}>
                <div className={classes.TextSide}>
                    <h1 className={classes.Title}>
                        {texts.heroTitlePart1}
                        <span className={classes.Accent}>{texts.heroTitleAccent1}</span>
                        {texts.heroTitlePart2}
                        <span className={classes.Accent}>{texts.heroTitleAccent2}</span>
                    </h1>
                </div>
                <div className={classes.GifSide} aria-hidden="true">
                    <img
                        src={resolveAssetUrl('/assets/hero-animation.gif')}
                        alt=""
                        className={classes.Gif}
                    />
                </div>
            </div>
        </section>
    );
};

export default Hero;
